const actions = {
  INPUT_NUMBER: "INPUT_NUMBER",
  INPUT_ACTION: "INPUT_ACTION",
  SHOW_RESULT: "SHOW_RESULT",
  ALL_CLEAR: "ALL_CLEAR",
  INPUT_UNDO: "INPUT_UNDO"
};

const initialState = {
  prevVal: "",
  currentVal: "",
  currentOperand: "",
  disableActions: false
};

const evaluteValues = (state) => {
    const { prevVal, currentVal, currentOperand } = state;
    // eslint-disable-next-line
    if(prevVal !== '' && currentVal !== '') return eval(`${prevVal}${currentOperand}${currentVal}`);
    if(prevVal === '' && currentVal !== '') return `${currentVal}`;
    if(prevVal !== '' && currentVal === '') return `${prevVal}`;
    return '';
}

const calcReducer = (state = initialState, action) => {
  const { type, payload } = action;
  const { prevVal, currentVal, currentOperand } = state;
  const currentValStr = currentVal.toString().trim();

  switch (type) {
    case actions.INPUT_NUMBER:
        let result = payload;
        
        if(payload === '.'){
          if(currentValStr.includes('.')) result = '';
          if(currentValStr === '') result = '0.';
        }
        // if(currentValStr.includes('.')){
        //   const decimalValues = currentValStr.split('.')[1];
        //   if(decimalValues.length > 10)
        // }

      return {
        ...state,
        currentVal: `${currentVal}${result}`,
      };

    case actions.INPUT_ACTION:
      return {
        ...state,
        prevVal: evaluteValues(state) || '',
        currentVal: "",
        currentOperand: (currentVal !== '' || prevVal !== '') ? payload : '',
      };

    case actions.SHOW_RESULT:
      if(currentOperand === '/' && Number(currentVal) === 0){
        alert('Divide by 0 error');
        return {...state}
      }
      return {
        ...state,
        prevVal: '',
        // eslint-disable-next-line
        currentVal: `${eval(`${prevVal}${currentOperand}${Number(currentVal)}`)}`,
        currentOperand: ''
      };

    case actions.ALL_CLEAR:
        return {
            ...initialState
        };

    case actions.INPUT_UNDO:
        return {
            ...state,
            currentVal: currentVal ? currentValStr.slice(0,-1) : currentVal
        };

    default:
      return state;
  }
};


export {
    actions, initialState
}

export default calcReducer;